import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './PaymentMethodIcon.module.scss.js';
import { AchIcon } from './icons/AchIcon.js';
import { AmexIcon } from './icons/AmexIcon.js';
import { DiscoverIcon } from './icons/DiscoverIcon.js';
import { MastercardIcon } from './icons/MastercardIcon.js';
import { VisaIcon } from './icons/VisaIcon.js';

var PaymentMethodIcon = function (_a) {
    var type = _a.type, brand = _a.brand, className = _a.className, style = _a.style;
    var icon;
    var alt;
    if (type === 'ACH') {
        icon = jsx(AchIcon, {});
        alt = 'Bank transfer';
    }
    else if (type === 'CREDIT') {
        switch (brand) {
            case 'VISA':
                icon = jsx(VisaIcon, {});
                alt = 'Visa card';
                break;
            case 'MASTERCARD':
                icon = jsx(MastercardIcon, {});
                alt = 'Mastercard';
                break;
            case 'DISCOVER':
                icon = jsx(DiscoverIcon, {});
                alt = 'Discover card';
                break;
            case 'AMEX':
                icon = jsx(AmexIcon, {});
                alt = 'American Express card';
                break;
        }
    }
    if (!icon || !alt) {
        return null;
    }
    return (jsx("div", __assign({ className: clsx(styles.paymentMethodIcon, className), style: style, title: alt }, { children: icon })));
};

export { PaymentMethodIcon };
